/* DRYRIDE — storefront behaviour */
(() => {
  const DR = window.DR || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(DR.locale || 'nl-NL', { style: 'currency', currency: DR.currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  };

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  $$('.reveal').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

  /* Mobile menu */
  const toggle = $('[data-menu-toggle]');
  const mnav = $('[data-mobile-nav]');
  if (toggle && mnav) {
    toggle.addEventListener('click', () => {
      const open = mnav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
    $$('a', mnav).forEach((a) => a.addEventListener('click', () => { mnav.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }));
  }

  /* Rain */
  $$('canvas[data-rain]').forEach((canvas) => {
    if (reduced) return;
    const ctx = canvas.getContext('2d');
    let w, h, drops = [], running = false, raf;
    const density = parseFloat(canvas.dataset.rain) || 1;
    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.round((w * h) / 9000 * density);
      drops = Array.from({ length: n }, () => ({ x: Math.random() * w, y: Math.random() * h, l: 10 + Math.random() * 22, v: 9 + Math.random() * 12, o: 0.08 + Math.random() * 0.28 }));
    };
    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      ctx.lineCap = 'round';
      for (const d of drops) {
        ctx.strokeStyle = `rgba(200, 225, 255, ${d.o})`;
        ctx.lineWidth = d.l > 24 ? 1.4 : 1;
        ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x - d.l * 0.18, d.y + d.l); ctx.stroke();
        d.y += d.v; d.x -= d.v * 0.18;
        if (d.y > h) { d.y = -d.l; d.x = Math.random() * (w + 60); }
      }
      raf = requestAnimationFrame(tick);
    };
    resize();
    window.addEventListener('resize', resize, { passive: true });
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !running) { running = true; tick(); }
      else if (!e.isIntersecting && running) { running = false; cancelAnimationFrame(raf); }
    }).observe(canvas);
  });

  /* 3D: Shopify / Google model-viewer when a GLB exists, tilt stage otherwise */
  if ($('model-viewer') && !customElements.get('model-viewer')) {
    const s = document.createElement('script');
    s.type = 'module';
    s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
    document.head.appendChild(s);
  }
  $$('[data-tilt]').forEach((stage) => {
    const card = $('.tilt__card', stage);
    let rot = -18, tiltX = 4, dragging = false, startX = 0, startRot = 0, idle = true, last = performance.now();
    const apply = () => { card.style.transform = `rotateX(${tiltX}deg) rotateY(${rot}deg)`; };
    const loop = (t) => {
      const dt = Math.min(64, t - last); last = t;
      if (idle && !reduced) { rot += dt * 0.018; apply(); }
      requestAnimationFrame(loop);
    };
    stage.addEventListener('pointerdown', (e) => { dragging = true; idle = false; startX = e.clientX; startRot = rot; stage.setPointerCapture(e.pointerId); });
    stage.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      rot = startRot + (e.clientX - startX) * 0.6;
      tiltX = 4 + ((e.clientY - stage.getBoundingClientRect().top) / stage.clientHeight - 0.5) * -10;
      apply();
    });
    const end = () => { if (!dragging) return; dragging = false; setTimeout(() => { idle = true; }, 1800); };
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    apply();
    requestAnimationFrame(loop);
  });

  /* Hotspot list: highlight one feature after another */
  $$('[data-hotspots]').forEach((list) => {
    const items = $$('.hotspot', list);
    if (!items.length) return;
    let i = 0, timer;
    const show = (n) => { items.forEach((it, k) => it.classList.toggle('is-active', k === n)); };
    const run = () => { timer = setInterval(() => { i = (i + 1) % items.length; show(i); }, 2600); };
    items.forEach((it, k) => it.addEventListener('mouseenter', () => { clearInterval(timer); i = k; show(k); }));
    list.addEventListener('mouseleave', run);
    show(0); if (!reduced) run();
  });

  /* Gallery */
  $$('[data-gallery]').forEach((g) => {
    const track = $('.gallery__slides', g);
    const slides = $$('.gallery__slide', g);
    const thumbs = $$('.gallery__thumb', g);
    const go = (n) => { const s = slides[Math.max(0, Math.min(slides.length - 1, n))]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); };
    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    $('[data-prev]', g)?.addEventListener('click', () => go(current() - 1));
    $('[data-next]', g)?.addEventListener('click', () => go(current() + 1));
    const delay = parseInt(g.dataset.autoplay, 10);
    if (delay && slides.length > 1 && !reduced) {
      let visible = false, stopped = false;
      const stop = () => { stopped = true; };
      ['pointerdown', 'wheel', 'keydown'].forEach((ev) => g.addEventListener(ev, stop, { passive: true }));
      if (io) new IntersectionObserver(([e]) => { visible = e.isIntersecting; }, { threshold: 0.4 }).observe(g);
      setInterval(() => { if (visible && !stopped && !document.hidden) go((current() + 1) % slides.length); }, delay);
    }
    let to;
    track.addEventListener('scroll', () => {
      clearTimeout(to);
      to = setTimeout(() => {
        const c = current();
        thumbs.forEach((t, k) => t.setAttribute('aria-current', k === c ? 'true' : 'false'));
        thumbs[c]?.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }, 60);
    }, { passive: true });
  });

  /* Quantity + pack pickers */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, Math.min(20, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10)));
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('.pack input')) {
      const form = e.target.closest('form');
      $$('.pack', form).forEach((p) => p.classList.toggle('is-picked', p.contains(e.target)));
      $$('[data-sticky-price]').forEach((el) => { el.textContent = e.target.dataset.price; });
    }
  });

  /* Cart drawer */
  const drawer = $('[data-drawer]');
  const routes = DR.routes || {};
  const t = DR.t || {};
  const countEls = $$('[data-cart-count]');
  const openDrawer = () => { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; $('[data-drawer-close]', drawer)?.focus(); };
  const closeDrawer = () => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
  $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  $$('[data-open-cart]').forEach((a) => a.addEventListener('click', (e) => { if (!drawer) return; e.preventDefault(); renderCart().then(openDrawer); }));

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const lineTitle = (item) => (DR.featuredId && item.product_id === DR.featuredId ? DR.featuredName : item.product_title);
  const variantTitle = (item) => {
    if (item.product_has_only_default_variant) return '';
    if (DR.featuredId && item.product_id === DR.featuredId && DR.packs) {
      const idx = DR.packs.indexOf(item.variant_id);
      if (idx > -1 && t.packs && t.packs[idx]) return t.packs[idx];
    }
    return item.variant_title || '';
  };

  async function renderCart() {
    const cart = await fetch(routes.cart_js).then((r) => r.json());
    countEls.forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    if (!drawer) return cart;
    const body = $('[data-drawer-body]', drawer);
    const foot = $('[data-drawer-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = `<div class="drawer__empty"><p>${esc(t.empty)}</p></div>`;
      foot.hidden = true;
      return cart;
    }
    foot.hidden = false;
    let html = cart.items.map((item) => `
      <div class="line">
        <a class="line__img" href="${item.url}">${item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2')}" alt="" loading="lazy" width="76" height="76">` : ''}</a>
        <div>
          <div class="line__title">${esc(lineTitle(item))}</div>
          ${variantTitle(item) ? `<div class="line__variant">${esc(variantTitle(item))}</div>` : ''}
          <div class="line__qty">
            <button type="button" data-line="${item.key}" data-q="${item.quantity - 1}" aria-label="-">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-line="${item.key}" data-q="${item.quantity + 1}" aria-label="+">+</button>
          </div>
        </div>
        <div class="line__price">${money(item.final_line_price)}</div>
      </div>`).join('');
    const single = DR.packs && cart.items.find((i) => i.variant_id === DR.packs[0] && i.quantity === 1);
    const hasDuo = DR.packs && cart.items.some((i) => i.variant_id === DR.packs[1]);
    if (single && !hasDuo && DR.duoPrice) {
      const extra = DR.duoPrice - DR.singlePrice;
      html += `
        <div class="upsell">
          ${DR.duoImage ? `<img src="${DR.duoImage}" alt="" width="56" height="56" loading="lazy">` : ''}
          <div><strong>${esc(t.upsell_title)}</strong><span>${esc((t.upsell_text || '').replace('{{ price }}', money(extra)))}</span></div>
          <button type="button" class="btn btn--accent" data-upgrade="${single.key}">${esc(t.upsell_add)}</button>
        </div>`;
    }
    body.innerHTML = html;
    $('[data-drawer-total]', drawer).textContent = money(cart.total_price);
    return cart;
  }

  drawer?.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-line]');
    const up = e.target.closest('[data-upgrade]');
    if (q) {
      q.disabled = true;
      await fetch(routes.cart_change, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: q.dataset.line, quantity: Math.max(0, parseInt(q.dataset.q, 10)) }) });
      renderCart();
    } else if (up) {
      up.disabled = true;
      await fetch(routes.cart_change, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: up.dataset.upgrade, quantity: 0 }) });
      await fetch(routes.cart_add, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: DR.packs[1], quantity: 1 }] }) });
      renderCart();
    }
  });

  $$('[data-buy-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (!drawer || !window.fetch) return;
      e.preventDefault();
      const btn = $('[data-add]', form);
      const label = $('span', btn);
      const err = $('[data-error]', form);
      btn.disabled = true; label.textContent = btn.dataset.adding; err.hidden = true;
      try {
        const res = await fetch(routes.cart_add, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        await renderCart();
        openDrawer();
      } catch (ex) {
        err.textContent = ex.message; err.hidden = false;
      } finally {
        btn.disabled = false; label.textContent = btn.dataset.label;
      }
    });
  });

  /* Sticky buy bar appears once the main buy button scrolls away */
  const sticky = $('[data-sticky-buy]');
  const anchor = $('[data-sticky-anchor]');
  if (sticky && anchor && io) {
    new IntersectionObserver(([e]) => {
      const past = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', past);
    }).observe(anchor);
  }
  $$('[data-scroll-buy]').forEach((b) => b.addEventListener('click', (e) => {
    const target = $('[data-sticky-anchor]') || $('#offer');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }));
})();
